import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { SECTORS } from "./onboarding/constants";
import { Step1 } from "./onboarding/Step1";
import { Step2 } from "./onboarding/Step2";
import { Step3 } from "./onboarding/Step3";

export default function Onboarding() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [busy, setBusy] = useState(false);
  const [f, setF] = useState({
    investor_type: "", entity_name: "", accredited: false,
    regions: [], stages: [], deal_flow: "", secondary_interest: null,
    sectors: [...SECTORS], venture_funds: null, fund_sizes: [],
    manager_experience: "", other_asset_classes: [],
  });

  if (user === false) return <Navigate to="/login" replace />;
  if (user && user.onboarded) return <Navigate to="/app" replace />;
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><span className="t-label">Solera</span></div>;

  const toggle = (k, v) => setF({ ...f, [k]: f[k].includes(v) ? f[k].filter((x) => x !== v) : [...f[k], v] });

  const step1Valid = f.investor_type && f.accredited && f.regions.length > 0 && (f.investor_type !== "entity" || f.entity_name);
  const step2Valid = f.stages.length > 0 && f.deal_flow && f.sectors.length > 0;
  const step3Valid = f.secondary_interest !== null && f.venture_funds !== null;

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/auth/onboarding", { ...f, manager_experience: f.manager_experience || null });
      setUser(data);
      navigate("/app");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen" data-testid="onboarding-page">
      <header className="max-w-2xl mx-auto px-6 pt-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="solera-symbol" />
          <span className="wordmark text-bone text-sm">Solera</span>
        </div>
        <span className="t-label">Complete your profile</span>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-16">
        <span className="t-label">Step {step} of 3{step === 3 ? " - last step" : ""}</span>

        {step === 1 && <Step1 f={f} setF={setF} toggle={toggle} valid={step1Valid} onNext={() => setStep(2)} />}
        {step === 2 && <Step2 f={f} setF={setF} toggle={toggle} valid={step2Valid} onBack={() => setStep(1)} onNext={() => setStep(3)} />}
        {step === 3 && <Step3 f={f} setF={setF} toggle={toggle} valid={step3Valid} busy={busy} onBack={() => setStep(2)} onSubmit={submit} />}
      </main>
    </div>
  );
}
